export default function () {
    return {
        KEYS: {
            USER_DEFINED_ROLE: 'USER_DEFINED_ROLE',
            SYSTEM_ROLE: 'SYSTEM_ROLE',
            DEFAULT_ROLE: 'DEFAULT_ROLE'
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/role/type/index.js